/* BHS v2.7 — policy links open in a closable pop-up (from SPS v9.8 sps-policy-modal.js, Back-button fix):
   - opening a policy shows /policies/<name> in the address bar and adds ONE history step, so Back closes the pop-up;
   - switching policies inside the pop-up only updates the address (no extra steps);
   - x / Close / Esc / tap outside also undo that step (the address returns to the page);
   - a link to the policy page already open underneath closes the pop-up instead of re-opening it;
   - links are compared with the page's original path (PAGE), not the current address;
   - tracking / session parameters are removed from the address bar 1.5 s after load.
   Replaces part 1 of bhs-custom.js and the two URL scripts formerly in sections/bhs-optin-bar.liquid. */
(function () {
  if (window.__bhsPolicyModal) return;
  window.__bhsPolicyModal = true;
  var POLICY_RE = /\/policies\/[^\/?#]+/, PAGE = location.pathname;
  var cache = {}, ready = {}, modal = null, titleEl = null, bodyEl = null, lastFocus = null, token = 0, pushed = false, current = null;

  function withPreview(p) {
    var pv = null;
    try { pv = new URL(location.href).searchParams.get('preview_theme_id'); } catch (e) {}
    return p + (pv ? '?preview_theme_id=' + pv : '');
  }
  function setUrl(p) {
    current = p;
    try {
      if (!pushed) { history.pushState({ bhsPm: 1 }, '', withPreview(p)); pushed = true; }
      else history.replaceState({ bhsPm: 1 }, '', withPreview(p));
    } catch (e) {}
  }
  function build() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'bhs-pm';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'bhs-pm-title');
    modal.innerHTML =
      '<div class="bhs-pm__box"><div class="bhs-pm__head"><h2 class="bhs-pm__title" id="bhs-pm-title"></h2>' +
      '<button type="button" class="bhs-pm__close" aria-label="Close">&times;</button></div>' +
      '<div class="bhs-pm__body" tabindex="0"></div>' +
      '<div class="bhs-pm__foot"><button type="button" class="bhs-pm__btn">Close</button></div></div>';
    document.body.appendChild(modal);
    titleEl = modal.querySelector('.bhs-pm__title');
    bodyEl = modal.querySelector('.bhs-pm__body');
    modal.querySelector('.bhs-pm__close').addEventListener('click', function () { close(); });
    modal.querySelector('.bhs-pm__btn').addEventListener('click', function () { close(); });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
  }
  function show() {
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    modal.querySelector('.bhs-pm__close').focus();
  }
  /* hide the pop-up only (no history change) */
  function hide() {
    token++;
    current = null;
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  /* closed by the visitor: hide and undo the history step it added */
  function close() {
    hide();
    if (pushed) { pushed = false; try { history.back(); } catch (e) {} }
  }
  window.addEventListener('popstate', function (e) {
    if (pushed && !(e.state && e.state.bhsPm)) { pushed = false; hide(); }
  });
  function load(path) {
    if (cache[path]) return cache[path];
    var p = fetch(path, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http_' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var body = doc.querySelector('.shopify-policy__body');
        if (!body) throw new Error('no_body');
        var t = doc.querySelector('.shopify-policy__title');
        body.querySelectorAll('script, style, iframe, form').forEach(function (n) { n.remove(); });
        var data = { title: t ? t.textContent.trim() : '', html: body.innerHTML };
        ready[path] = data;
        return data;
      });
    cache[path] = p;
    p.catch(function () { delete cache[path]; });
    return p;
  }
  function fixLinks() {
    bodyEl.querySelectorAll('a[href]').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) === '#' || a.protocol === 'mailto:' || a.protocol === 'tel:') return;
      if (a.origin === location.origin && POLICY_RE.test(a.pathname)) { a.removeAttribute('target'); return; }
      a.target = '_blank';
      a.rel = 'noopener';
    });
  }
  function render(data, fallback) {
    titleEl.textContent = data.title || fallback || '';
    bodyEl.innerHTML = data.html;
    if (window.bhsHideEmpty) window.bhsHideEmpty(bodyEl);
    fixLinks();
    bodyEl.scrollTop = 0;
  }
  function openPolicy(path, trigger, fallback) {
    build();
    if (modal.hidden) lastFocus = trigger;
    setUrl(path);
    if (ready[path]) { render(ready[path], fallback); show(); return; }
    var mine = ++token;
    var timer = setTimeout(function () {
      if (mine !== token) return;
      titleEl.textContent = fallback || '';
      bodyEl.innerHTML = '<div class="bhs-pm__loading">Loading...</div>';
      show();
    }, 350);
    load(path).then(function (data) {
      clearTimeout(timer);
      if (mine === token) { render(data, fallback); show(); }
    }).catch(function () {
      clearTimeout(timer);
      if (mine === token) { hide(); location.href = path; }
    });
  }
  function prefetch() {
    if (navigator.connection && navigator.connection.saveData) return;
    var paths = [], seen = {};
    document.querySelectorAll('a[href]').forEach(function (a) {
      var u; try { u = new URL(a.href, location.href); } catch (e) { return; }
      if (u.origin === location.origin && POLICY_RE.test(u.pathname) && u.pathname !== PAGE && !seen[u.pathname]) {
        seen[u.pathname] = true; paths.push(u.pathname);
      }
    });
    var i = 0;
    (function next() {
      if (i >= paths.length) return;
      load(paths[i++]).catch(function () {}).then(function () { setTimeout(next, 150); });
    })();
  }
  function schedulePrefetch() {
    if ('requestIdleCallback' in window) window.requestIdleCallback(prefetch, { timeout: 4000 });
    else setTimeout(prefetch, 2000);
  }
  if (document.readyState === 'complete') schedulePrefetch(); else window.addEventListener('load', schedulePrefetch);

  document.addEventListener('click', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!link) return;
    var u; try { u = new URL(link.href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin || !POLICY_RE.test(u.pathname)) return;
    var open = modal && !modal.hidden;
    if (u.pathname === PAGE) {
      /* the policy page underneath: just close the pop-up (or do nothing if none is open) */
      if (open || pushed) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); close(); }
      return;
    }
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    if (open && u.pathname === current) return;
    openPolicy(u.pathname, link, (link.textContent || '').trim());
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) close(); });

  /* clean tracking / session parameters from the address bar (search, filters, variant and preview stay) */
  (function () {
    if (!location.search) return;
    var R = /^(pr_|utm_|_su_)|^(country|locale|currency|gclid|gbraid|wbraid|fbclid|msclkid|ttclid|twclid|srsltid|_gl|_pos|_sid|_ss|_kx|_psq|mc_cid|mc_eid|logged_in|customer_posted|contact_posted|form_type)$/i;
    function clean() {
      setTimeout(function () {
        if (pushed) return;
        var u = new URL(location.href), ks = [];
        u.searchParams.forEach(function (v, k) { if (R.test(k)) ks.push(k); });
        if (!ks.length) return;
        ks.forEach(function (k) { u.searchParams.delete(k); });
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      }, 1500);
    }
    if (document.readyState === 'complete') clean(); else window.addEventListener('load', clean);
  })();
})();